export enum FitAnswer {
  none = -1,
  veryTight = 0,
  tight = 4,
  littleTight = 8,
  normal = 12,
  littleLoose = 16,
  loose = 20,
  veryLoose = 24,
}

export enum SizeAnswer {
  none = -1,
  verySmall = 0,
  small = 4,
  littleSmall = 8,
  normal = 12,
  littleLarge = 16,
  large = 20,
  veryLarge = 24,
}

export enum LengthAnswer {
  none = -1,
  veryShort = 0,
  short = 4,
  littleShort = 8,
  normal = 12,
  littleLong = 16,
  long = 20,
  veryLong = 24,
}

export enum FitLikeAnswer {
  none = 0,
  no = 1,
  unsure = 2,
  yes = 3,
}

export enum ReturningAnswer {
  none = 0,
  returning = 1,
  unsure = 2,
  keeping = 3,
}

export enum BraSupportAnswer {
  none = -1,
  veryLow = 0,
  low = 4,
  littleLow = 8,
  medium = 12,
  littleHigh = 16,
  high = 20,
  veryHigh = 24,
}

export enum ComfortAnswer {
  none = -1,
  veryLow = 0,
  low = 4,
  littleLow = 8,
  medium = 12,
  littleHigh = 16,
  high = 20,
  veryHigh = 24,
}

export enum SkinConcernAnswer {
  blemishesBreakouts = 'blemishesBreakouts',
  pores = 'pores',
  unevenTexture = 'unevenTexture',
  blackheads = 'blackheads',
  fineLinesWrinkles = 'fineLinesWrinkles',
  drynessDehydration = 'drynessDehydation',
  redness = 'redness',
  hyperPigmentation = 'hyperPigmentation',
  oiliness = 'oiliness',
}
